import { geoApi } from 'api'
import { ProcessingKey } from 'constants/rootConstants'
import type { IGeoDataResponse } from 'models/geo.model'
import { useZustandStore } from 'zustandGlobalStore'

export const fetchGeoData = async (): Promise<IGeoDataResponse | null> => {
  useZustandStore.getState().startProcessing(ProcessingKey.FETCH_GEO_DATA)

  try {
    const response = await geoApi.getGeoData()
    const responseData = response.data
    useZustandStore.setState({ geoData: responseData })
    useZustandStore.getState().stopProcessing(ProcessingKey.FETCH_GEO_DATA)
    return responseData
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    useZustandStore.getState().stopProcessing(ProcessingKey.FETCH_GEO_DATA)
    return null
  }
}
